import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { ActionCoAction, ActionCoCardModel, ActionCoDevisModel, ActionCoLigneDevis, CRUD } from '../../../models';
import { HttpService, CoreService } from '../../../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-cac',
  templateUrl: './action-co-cac.component.html',
  styleUrls: ['./action-co-cac.component.css', '../action-co-card.component.css', '../action-co-action/action-co-action.component.css',]
})

export class ActionCoCacComponent implements OnInit {
  @Input() actionCoCard: ActionCoCardModel;
  @Output() modelChange: EventEmitter<ActionCoCardModel> = new EventEmitter<ActionCoCardModel>();
  @Output() getHistory: EventEmitter<void> = new EventEmitter<void>();

  public model: ActionCoDevisModel = new ActionCoDevisModel();

  public modeBo: string = '';
  public IdContact: string;
  public IdContactPrincipal: string;
  public Loaded = false;
  public LoadedDevis = false;
  public LoadedCatalogue = false;
  public CRUD = CRUD;
  public TempLigne: ActionCoLigneDevis;
  public EditingOption: number;
  public EditingLigne: number;
  public Newline: boolean = false;
  public Editing: boolean = false;
  public SaveInprogress: boolean = false;

  public selectParcoursDevis: string;
  public QuantiteParcours: number = 1;

  public clickedThumb: string = '';


  constructor(
    protected http: HttpService,
    protected indParam: CoreService
  ) { }


  public ngOnInit(): void {
    }
      
}
